// extracted by mini-css-extract-plugin
export var actionButton = "_cl-0";
export var fileInput = "_cl-2";
export var paperclip = "_cl-1";